import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'boma-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.scss'],
})
export class ChartsComponent implements OnInit {
  @Input() chartType = 'bar';
  @Input() data;
  constructor() {}

  ngOnInit(): void {}
}
